import PostTaskDiscoOverlay from './PostTaskDiscoOverlay';

export default PostTaskDiscoOverlay;
